import { ICollectionResponse, ISearchRequestObject } from '@logz-build/typescript';

import { EventHistoryModel, EventModel } from '@logz-pkg/models';
import { ICrudApiService } from '../utilities/types';
import { CrudApiService } from '../utilities/crud.api.service';

export class EventHistoryApiService implements ICrudApiService<EventHistoryModel> {
  constructor(public eventId: EventModel['id']) {}

  crudApiService = new CrudApiService<EventHistoryModel>({ modelDefinition: EventHistoryModel });

  urls = {
    search: eventId => `/event-manager/events/${eventId}/history`,
  };

  search = (requestObject: ISearchRequestObject): Promise<ICollectionResponse<EventHistoryModel>> =>
    this.crudApiService.search(this.urls.search(this.eventId), requestObject);
}

export class CorrelatedEventHistoryApiService implements ICrudApiService<EventHistoryModel> {
  constructor(public eventId: EventModel['id']) {}

  crudApiService = new CrudApiService<EventHistoryModel>({ modelDefinition: EventHistoryModel });

  urls = {
    search: eventId => `/v2/event-manager/siem/events/${eventId}/history`,
  };

  search = (requestObject: ISearchRequestObject): Promise<ICollectionResponse<EventHistoryModel>> =>
    this.crudApiService.search(this.urls.search(this.eventId), requestObject);
}
